export default __webpack_public_path__ + "locales/pt-BR/ChangeUserStatusDialog.json?hash=aaaedcdfc376dfe0d4fc989dd82bfc96";